import axios from 'axios';

const API = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api/laeformacion`,
});

API.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// — Categorías
export const getCategorias    = (params)   => API.get('/categorias', { params });
export const getCategoria     = (id)       => API.get(`/categorias/${id}`);
export const createCategoria  = (data)     => API.post('/categorias', data);
export const updateCategoria  = (id, data) => API.put(`/categorias/${id}`, data);
export const deleteCategoria  = (id)       => API.delete(`/categorias/${id}`);

// — Cursos
export const getCursos         = (params)      => API.get('/cursos', { params });
export const getCurso          = (id)          => API.get(`/cursos/${id}`);
export const createCurso       = (data)        => API.post('/cursos', data);
export const updateCurso       = (id, data)    => API.put(`/cursos/${id}`, data);
export const deleteCurso       = (id)          => API.delete(`/cursos/${id}`);
export const toggleCursoActivo    = (id, activo)        => API.patch(`/cursos/${id}/activo`, { activo });
export const togglePublicadoCurso = (id, publicado_web) => API.patch(`/cursos/${id}/publicado`, { publicado_web });
export const subirImagenCurso = (id, file) => {
  const fd = new FormData();
  fd.append('imagen', file);
  // NO fijamos Content-Type a mano: el browser/axios añade el boundary
  // automáticamente para FormData. Si lo fijamos a 'multipart/form-data'
  // sin boundary, multer en backend no puede parsear y req.file queda undefined.
  return API.post(`/cursos/${id}/imagen`, fd);
};
// URL del proxy de imagen. NO usable con <img src=...> directamente porque el
// browser no manda el Bearer; úsala con el hook useImagenBlob para que la
// descargue con auth y devuelva un ObjectURL.
export const imagenCursoUrl = (name) =>
  name ? `${process.env.REACT_APP_API_URL}/api/laeformacion/cursos/imagen/${name}` : null;

// — Proveedores (común SEPE + LAE)
export const getProveedores   = (params)   => API.get('/proveedores', { params });
export const createProveedor  = (data)     => API.post('/proveedores', data);
export const updateProveedor  = (id, data) => API.put(`/proveedores/${id}`, data);
export const deleteProveedor  = (id)       => API.delete(`/proveedores/${id}`);

export default API;
